// Success.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../api/auth";

const Success = () => {
  const navigate = useNavigate();
  const [userFetched, setUserFetched] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      setUserFetched(true);
      return;
    }

    getUserInfo()
      .then((data) => {
        setUserFetched(true);
      })
      .catch((err) => {
        setUserFetched(true);
      });
  }, []);

  if (!userFetched) return null;

  return (
    <Box p={4} maxWidth="600px" mx="auto" textAlign="center">
      <Typography variant="h4" gutterBottom>お申し込みありがとうございました！</Typography>
      <Typography variant="body1" gutterBottom>プランの変更が完了しました。</Typography>
      <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={() => navigate("/settings/plan")}>
        プラン設定に戻る
      </Button>
    </Box>
  );
};

export default Success;
